import _ from "lodash";
import { getIsAssessmentTypeConfigurationEnabled } from "Utils/ACLStoreUtils";

export const getTitle = ({ parentType, parent }) => {
  switch (parentType) {
    case "STUDENT_PROGRESS_REPORT":
      return _.get(parent, "courseProgressReportTask.title", "") || "Untitled";
    case "STUDENT_ASSESSMENT_EVALUATION":
      return _.get(parent, "assessment.title.value", "") || "Untitled";
    case "POST":
      if (
        _.isEmpty(_.get(parent, "title", "")) &&
        _.size(_.get(parent, "attachments", []), 0) > 0
      ) {
        const noteAttachment = _.filter(
          _.get(parent, "attachments", []),
          attachment => _.get(attachment, "type", "") == "NOTE"
        );
        if (_.size(noteAttachment, 0) > 0) {
          const noteLine = _.get(noteAttachment[0], "title", "Untitled");
          return _.isEmpty(noteLine) ? "Untitled" : noteLine;
        }
      }
      return _.get(parent, "title", "") || "Untitled";
    case "STUDENT_ASSIGNMENT":
      return _.get(parent, "assignment.content.title.value", "") || "Untitled";
    case "IMPORTED_ENTITY":
      return _.get(parent, "name", "") || "Untitled";

    default:
      return "Observation";
  }
};
export const getRatingHistoryParentType = ({ parentType, parent }) => {
  if (_.isEqual(parentType, "IMPORTED_ENTITY")) {
    return _.get(parent, "type", "");
  }
  return parentType;
};
export const getAssociatedIconInfo = ({ parentType, parent, t }) => {
  switch (parentType) {
    case "STUDENT_ASSIGNMENT":
    case "STUDENT_ASSESSMENT_EVALUATION": {
      const assesmentType =
        parentType === "STUDENT_ASSIGNMENT"
          ? _.get(parent, "assignment.content.assessmentType.value", {})
          : _.get(parent, "assessment.assessmentType.value", {});

      if (getIsAssessmentTypeConfigurationEnabled()) {
        const taskType =
          parentType === "STUDENT_ASSIGNMENT"
            ? _.get(parent, "assignment.content.taskType", {})
            : _.get(parent, "assessment.taskType", {});
        return {
          iconColor: taskType.color || "neutral",
          iconAssessmentTypeLabel: taskType.label || t("common:na"),
        };
      }

      switch (assesmentType) {
        case "fmt":
          return {
            iconColor: "yellow",
            iconAssessmentTypeLabel: t("common:formative_assessment"),
          };

        case "smt":
          return {
            iconColor: "teal",
            iconAssessmentTypeLabel: t("common:summative_assessment"),
          };

        case "le":
          return {
            iconColor: "violet",
            iconAssessmentTypeLabel: t("common:le_label"),
          };
        case "qt":
          return {
            iconColor: "blue",
            iconAssessmentTypeLabel: t("common:quick_task"),
          };

        case "pri":
          return {
            iconAssessmentTypeLabel: t("classRoom:pre_assessment"),
          };

        case "pt":
          return {
            iconAssessmentTypeLabel: t("common:performance_task"),
          };

        case "se":
          return {
            iconAssessmentTypeLabel: t("common:supplementary_evidence"),
          };

        default:
          return {
            iconColor: "neutral",
            iconAssessmentTypeLabel: t("common:na"),
          };
      }
    }

    case "STUDENT_PROGRESS_REPORT":
      return { iconAssessmentTypeLabel: t("common:report_card") };
    case "POST":
      return { iconAssessmentTypeLabel: t("common:post") };
    default:
      return { iconAssessmentTypeLabel: "" };
  }
};

export const isAnyCriteriaGradeCommonInSelectedGrades = ({
  selectedGrades,
  gradeIds,
}) => {
  return _.some(gradeIds, id => _.find(selectedGrades, grade => grade === id));
};
